import { useQuery } from "@tanstack/react-query";
import { getEventsByUser } from "../api/eventsApi";

export const useGetEventsByUser = (startDate: string, endDate: string) => {
    return useQuery({
        queryKey: ['events-by-user', startDate, endDate],
        queryFn: () => getEventsByUser(startDate, endDate),
        staleTime: 1000 * 60 * 10,
        enabled: !!startDate && !! endDate,
    });
}